import { render, staticRenderFns } from "./BelangrijkeInformatie.vue?vue&type=template&id=173d2945&"
import script from "./BelangrijkeInformatie.vue?vue&type=script&lang=js&"
export * from "./BelangrijkeInformatie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports